import { render, staticRenderFns } from "./CreateTemplateOld.vue?vue&type=template&id=2782406d&scoped=true"
import script from "./CreateTemplateOld.vue?vue&type=script&lang=js"
export * from "./CreateTemplateOld.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateOld.vue?vue&type=style&index=0&id=2782406d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2782406d",
  null
  
)

export default component.exports